import {actionTypes as NotifActions} from "../_metronic/_partials/notification/NotificationRedux";
import {actionTypes as loadingActions} from "./ActionsLoadingRedux";
import {removeStorage} from "../_metronic/_helpers";

export default function setupAxios(axios, store) {

    const baseUrl = 'https://core.brandinja.ir/api';
    // const baseUrl = 'http://127.0.0.1:8000/api';
    axios.interceptors.request.use(
        config => {
            const {
                auth: {authToken}
            } = store.getState();

            if (authToken) {
                config.headers.Authorization = `Bearer ${authToken}`;
            }
            // config.baseURL =
            config.baseURL = baseUrl;

            return config;
        },
        err => Promise.reject(err)
    );
    axios.interceptors.response.use(res => {
        if (res.config.method == 'put' || res.config.method == 'post') {
            store.dispatch({type: NotifActions.Success})
        }
        // store.dispatch({ type: loadingActions.ActionsLoading, payload: false});
        return res

    }, function (error) {
        // Do something with response error
        store.dispatch({type: NotifActions.Open, payload: true});
        if (error.response.status === 403) {
            removeStorage('persist:trendyol-key');
            window.location.href = '/auth'
        }
        return error;
    });
}